import HtmlViewer from './HtmlViewer.vue';

export default HtmlViewer;
